import { flatMap } from 'lodash-es';

import type { AdvertisingMap, AdvertisingZone } from '@zoomit/web-kit';

export const mapModule = (zones: AdvertisingZone[]) => {
  return flatMap(zones, (zone) => zone.displayModules)
    .filter((module) => module && Object.keys(module).length !== 0)
    .reduce<AdvertisingMap>(
      (pre, curr) => ({
        ...pre,
        ...{ [curr.position.positionId]: [...((pre as any)[curr.position.positionId] || []), curr] },
      }),
      {} as any,
    );
};
